<template>
  <div>
    <Head title="Data Pertanggung Jawaban" />
    <h1 class="mb-8 text-2xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/accountability-reports">Pertanggung Jawaban</Link>
      <span class="font-medium text-indigo-400">/</span>
      {{ application.periode }}
    </h1>
    <div v-if="!statusInput" class="w-full mb-8 bg-white rounded-md shadow">
      <div class="flex justify-between w-full px-8 py-6 bg-gray-200">
        <h2 class="text-xl">Informasi Pertanggung Jawaban </h2>
        <Button v-if="can('write permohonan beasiswa') && (application.status == 0 || application.status == 2) && isValid" type="button" class="btn-green" @click.prevent="kirim">
          <span><font-awesome-icon icon="fas fa-paper-plane" class="mr-2" />Kirim Pertanggung Jawaban</span>
        </Button>
      </div>
      <div class="flex w-full">
        <div class="flex flex-wrap w-full p-6 leading-10 lg:w-3/4">
          <dt class="w-full lg:w-4/12">Periode Beasiswa</dt>
          <dd class="w-full lg:w-8/12">: {{ application.periode }}</dd>
          <dt class="w-full lg:w-4/12">NIM Pemohon</dt>
          <dd class="w-full lg:w-8/12">: {{ application.nim }}</dd>
          <dt class="w-full lg:w-4/12">Nama Pemohon</dt>
          <dd class="w-full lg:w-8/12">: {{ application.nama_pemohon }}</dd>
          <dt class="w-full lg:w-4/12">Nama Universitas</dt>
          <dd class="w-full lg:w-8/12">: {{ application.nama_universitas }}</dd>
          <dt class="w-full lg:w-4/12">Program Studi</dt>
          <dd class="w-full lg:w-8/12">: {{ application.nama_prodi }}</dd>
          <dt class="w-full lg:w-4/12">Jalur Prestasi</dt>
          <dd class="w-full lg:w-8/12">: {{ application.is_berprestasi }}</dd>
        </div>
        <div class="flex flex-wrap w-full p-6 leading-10 lg:w-1/2">
          <dt class="w-full lg:w-4/12">Semester</dt>
          <dd class="w-full lg:w-8/12">: {{ application.semester }}</dd>
          <dt class="w-full lg:w-4/12">Nilai IPK</dt>
          <dd class="w-full lg:w-8/12">: {{ application.ipk }}</dd>
          <dt class="w-full lg:w-4/12">No Rekening</dt>
          <dd class="w-full lg:w-8/12">: {{ application.account_number }}</dd>
        </div>
      </div>
    </div>

    <div class="w-full bg-white rounded-md shadow">
      <div class="flex justify-between w-full px-8 py-6 bg-gray-200">
        <h2 class="text-xl">File Persyaratan</h2>
        <Button v-if="can('write permohonan beasiswa') && (application.status == 0 || application.status == 1 || application.status == 2)" type="button" class="btn-indigo" @click.prevent="statusInput = true">
          <span><font-awesome-icon icon="fas fa-plus" class="mr-2" />Tambah</span>
        </Button>
      </div>
      <div v-if="!statusInput" class="p-6">
        <ul class="mt-2 ml-4 list-disc">
          <li v-for="syarat in persyaratans" :key="syarat.id" :class="{ 'form-error': !fileTypes.includes(syarat.id), 'form-valid': fileTypes.includes(syarat.id) }">
            {{ syarat.nama }} <font-awesome-icon v-if="fileTypes.includes(syarat.id)" icon="fas fa-check" class="text-green-700" />
          </li>
        </ul>
      </div>
      <table v-if="!statusInput" class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4">Jenis File</th>
            <th class="px-6 pt-6 pb-4 text-center">Status Verifikasi</th>
            <th v-if="can('write permohonan beasiswa')" class="px-6 pt-6 pb-4">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="file in application.files" :key="file.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="p-2 border-t">
              {{ file.persyaratan }}
            </td>
            <td class="p-2 text-center border-t">
              <span v-if="file.status == 0" class="px-4 py-1 text-sm bg-yellow-300 rounded-lg">Draft</span>
              <span v-else-if="file.status == 1" class="px-4 py-1 text-sm rounded-lg">-</span>
              <span v-else-if="file.status == 2" class="px-4 py-1 text-sm bg-red-300 rounded-lg">Belum Memenuhi Syarat</span>
              <span v-else-if="file.status == 3" class="px-4 py-1 text-sm bg-red-500 rounded-lg">Tidak Memenuhi Syarat</span>
              <span v-else class="px-4 py-1 text-sm bg-green-500 rounded-lg">Disetujui</span>
              <p class="mt-1 leading-4 text-gray-600">{{ file.catatan_verifikasi }}</p>
            </td>
            <td v-if="can('write permohonan beasiswa')" class="w-px p-4 border-t">
              <Button v-if="file.status == 0 || file.status == 2" type="button" class="rounded-l btn-red-sm" title="Hapus" @click.prevent="destroy(file.id)">
                <font-awesome-icon icon="fas fa-trash" />
              </Button>
              <Button type="button" title="Lihat File" class="rounded-r btn-green-sm" @click.prevent="viewImage(file.file_path)">
                <font-awesome-icon icon="fas fa-magnifying-glass" />
              </Button>
            </td>
          </tr>
          <tr v-if="application.files.length === 0">
            <td class="px-6 py-4 border-t" :colspan="can('write permohonan beasiswa')? 3 : 2">Tidak ada data file persayaratan yang diupload.</td>
          </tr>
        </tbody>
      </table>
      <form v-if="statusInput" @submit.prevent>
        <div class="flex flex-wrap p-8 -mb-8 -mr-6">
          <div class="w-full pb-8 pr-6 lg:w-1/3">
            <label for="persyaratan_id" class="form-label">Jenis</label>
            <v-select v-model="form.persyaratan_id" :options="persyaratans" :reduce="persyaratan => persyaratan.id" label="nama" placeholder="Pilih Jenis" />
            <div v-if="form.errors.persyaratan_id" class="form-error">{{ form.errors.persyaratan_id }}</div>
          </div>
          <file-input v-model="form.file" :error="form.errors.file" class="w-full pb-8 pr-6 lg:w-1/2" type="file" accept="image/*,application/pdf" label="File Persyaratan" @remove="imageData = ''" @input="handleFilePersyaratanSelect" />
        </div>
        <div v-if="imageData.length > 0" class="w-full p-8">
          <h3 class="mb-4 text-lg">Preview File :</h3>
          <img class="preview" :src="imageData" />
        </div>
        <div v-if="form.uploading" class="flex items-center px-8 py-2 text-blue-600 bg-blue-50">
          <font-awesome-icon icon="fas fa-spinner" class="mr-2 fa-spin" />Mengunggah...
        </div>
        <div v-if="form.uploadSuccess" class="flex items-center px-8 py-2 text-green-600 bg-green-50">
          <font-awesome-icon icon="fas fa-check-circle" class="mr-2" />Berhasil diunggah!
        </div>
        <div v-if="form.uploadError" class="flex items-center px-8 py-2 text-red-600 bg-red-50">
          <font-awesome-icon icon="fas fa-exclamation-circle" class="mr-2" />Gagal mengunggah: {{ form.uploadErrorMessage }}
        </div>
        <div class="flex items-center px-8 py-4 border-t border-gray-100 bg-gray-50">
          <Button type="button" class="btn-red" @click.prevent="reset">
            <font-awesome-icon class="mr-2" icon="fas fa-ban" />Batal
          </Button>
        </div>
      </form>
    </div>

    <div class="w-full mt-8 bg-white rounded-md shadow">
      <div class="flex justify-between w-full px-8 py-6 bg-gray-200">
        <h2 class="text-xl">Penggunaan Anggaran</h2>
        <Button v-if="can('write permohonan beasiswa') && (application.status == 0 || application.status == 2)" type="button" class="btn-indigo" @click.prevent="statusInputAnggaran = true">
          <span><font-awesome-icon icon="fas fa-plus" class="mr-2" />Tambah</span>
        </Button>
      </div>

      <form v-if="statusInputAnggaran" @submit.prevent>
        <div class="flex flex-wrap p-8 -mb-8 -mr-6">
          <div class="w-full pb-8 pr-6 lg:w-1/3">
            <label for="category" class="form-label">Jenis Penggunaan</label>
            <v-select v-model="formAnggaran.category" :options="categories" placeholder="Pilih Jenis" />
            <div v-if="formAnggaran.errors.category" class="form-error">{{ formAnggaran.errors.category }}</div>
          </div>
          <text-input
            v-model="formAnggaran.description" type="text" :error="formAnggaran.errors.description"
            class="w-full pb-8 pr-6 lg:w-1/3" label="Uraian Biaya"
          />
          <text-input
            v-model.number="formAnggaran.amount" type="number" :error="formAnggaran.errors.amount" step="any"
            class="w-full pb-8 pr-6 lg:w-1/3" label="Nominal"
          />
          <file-input v-model="formAnggaran.file" :error="formAnggaran.errors.file" class="w-full pb-8 pr-6 lg:w-1/2" type="file" accept="image/*,application/pdf" label="File Bukti (Nota/Kwitansi)" @remove="imageDataAnggaran = ''" @input="handleFileAnggaranSelect" />
        </div>
        <div v-if="imageDataAnggaran.length > 0" class="w-full p-8">
          <h3 class="mb-4 text-lg">Preview File Bukti:</h3>
          <img class="preview" :src="imageDataAnggaran" />
        </div>
        <div v-if="formAnggaran.uploading" class="flex items-center px-8 py-2 text-blue-600 bg-blue-50">
          <font-awesome-icon icon="fas fa-spinner" class="mr-2 fa-spin" />Mengunggah...
        </div>
        <div v-if="formAnggaran.uploadSuccess" class="flex items-center px-8 py-2 text-green-600 bg-green-50">
          <font-awesome-icon icon="fas fa-check-circle" class="mr-2" />Berhasil diunggah!
        </div>
        <div v-if="formAnggaran.uploadError" class="flex items-center px-8 py-2 text-red-600 bg-red-50">
          <font-awesome-icon icon="fas fa-exclamation-circle" class="mr-2" />Gagal mengunggah: {{ formAnggaran.uploadErrorMessage }}
        </div>
        <div class="flex items-center px-8 py-4 border-t border-gray-100 bg-gray-50">
          <Button type="button" class="btn-red" @click.prevent="resetAnggaran">
            <font-awesome-icon class="mr-2" icon="fas fa-ban" />Batal
          </Button>
        </div>
      </form>

      <table v-if="!statusInputAnggaran" class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4">Jenis / Uraian</th>
            <th class="px-6 pt-6 pb-4 text-right">Nominal</th>
            <th class="px-6 pt-6 pb-4 text-center">Status Verifikasi</th>
            <th v-if="can('write permohonan beasiswa')" class="px-6 pt-6 pb-4">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="detail in application.details" :key="detail.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="p-2 border-t">
              <p class="font-semibold">{{ detail.category }}</p>
              <p class="text-sm text-gray-600">{{ detail.description }}</p>
            </td>
            <td class="p-2 text-right border-t">
              {{ new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(detail.amount) }}
            </td>
            <td class="p-2 text-center border-t">
              <span v-if="detail.status == 0" class="px-4 py-1 text-sm bg-yellow-300 rounded-lg">Draft</span>
              <span v-else-if="detail.status == 1" class="px-4 py-1 text-sm rounded-lg">-</span>
              <span v-else-if="detail.status == 2" class="px-4 py-1 text-sm bg-red-300 rounded-lg">Belum Memenuhi Syarat</span>
              <span v-else-if="detail.status == 3" class="px-4 py-1 text-sm bg-red-500 rounded-lg">Tidak Memenuhi Syarat</span>
              <span v-else class="px-4 py-1 text-sm bg-green-500 rounded-lg">Disetujui</span>
              <p class="mt-1 leading-4 text-gray-600">{{ detail.catatan_verifikasi }}</p>
            </td>
            <td v-if="can('write permohonan beasiswa')" class="w-px p-4 border-t">
              <Button v-if="detail.status == 0 || detail.status == 2" type="button" class="btn-red-sm" title="Hapus" @click.prevent="destroyDetail(detail.id)">
                <font-awesome-icon icon="fas fa-trash" />
              </Button>

              <Button type="button" title="Lihat File" class="btn-green-sm" @click.prevent="viewImage(detail.file_path)">
                <font-awesome-icon icon="fas fa-magnifying-glass" />
              </Button>
            </td>
          </tr>
          <tr v-if="application.details.length === 0">
            <td class="px-6 py-4 border-t" :colspan="can('write permohonan beasiswa')? 5 : 4">Tidak ada data penggunaan anggaran yang diupload.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <image-viewer :src="imageSource" :show-modal="showImage" @close="showImage = false" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import ImageViewer from '../../Shared/ImageViewer.vue'
import TextInput from '@/Shared/TextInput'

export default {
  components: {
    Head,
    Link,
    FileInput,
    ImageViewer,
    TextInput,
  },
  layout: Layout,
  props: {
    application: Object,
    persyaratans: Array,
  },
  remember: ['form', 'formAnggaran'],
  data() {
    return {
      // State for Form File Persyaratan
      statusInput: false,
      imageData: '',
      form: this.$inertia.form({
        accountability_report_id: this.application.id,
        persyaratan_id: null,
        file: null,
        uploading: false,
        uploadSuccess: false,
        uploadError: false,
        uploadErrorMessage: '',
      }),

      // State for Form Penggunaan Anggaran
      statusInputAnggaran: false,
      imageDataAnggaran: '',
      categories: ['Biaya Pendidikan', 'Biaya Penunjang Lainnya'],
      formAnggaran: this.$inertia.form({
        accountability_report_id: this.application.id,
        category: null,
        description: null,
        amount: null,
        file: null,
        uploading: false,
        uploadSuccess: false,
        uploadError: false,
        uploadErrorMessage: '',
      }),

      // State for Image Viewer
      imageSource: '',
      showImage: false,
    }
  },
  computed: {
    fileTypes() {
      return this.application.files.map(file => file.persyaratan_id)
    },
    isValid() {
      // Validasi hanya jika ada persyaratan yang wajib
      if (this.persyaratans.some(s => s.is_required)) {
        return this.persyaratans
          .filter(syarat => syarat.is_required)
          .every(syarat => this.fileTypes.includes(syarat.id))
      }
      return true // Jika tidak ada yang wajib, maka selalu valid
    },
  },

  watch: {
    // Watch for perubahan on form.persyaratan_id - trigger upload if file already selected
    'form.persyaratan_id': function(newVal) {
      if (newVal && this.form.file && !this.form.uploading && !this.form.uploadSuccess) {
        this.autoUploadPersyaratan()
      }
    },
    // Watch for perubahan on form.file - trigger upload if persyaratan_id already selected
    'form.file': function(newVal) {
      if (newVal && this.form.persyaratan_id && !this.form.uploading && !this.form.uploadSuccess) {
        this.autoUploadPersyaratan()
      }
    },
  },
  methods: {
    // Methods for Image Preview
    handlePreview: function(input, imageDataProp) {
      if (input.files && input.files[0]) {
        var reader = new FileReader()
        reader.onload = (e) => {
          this[imageDataProp] = e.target.result
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    handleFilePersyaratanSelect(event) {
      // Preview image
      this.handlePreview(event.target, 'imageData')
      // Auto upload if persyaratan_id is selected
      if (this.form.persyaratan_id && event.target.files && event.target.files[0]) {
        this.autoUploadPersyaratan()
      }
    },
    handleFileAnggaranSelect(event) {
      // Preview image
      this.handlePreview(event.target, 'imageDataAnggaran')
      // Auto upload if all required fields are filled
      if (this.formAnggaran.category && this.formAnggaran.description && this.formAnggaran.amount && event.target.files && event.target.files[0]) {
        this.autoUploadAnggaran()
      }
    },
    viewImage(imgSource) {
      this.imageSource = imgSource
      this.showImage = true
    },

    // Auto-upload for File Persyaratan
    autoUploadPersyaratan() {
      if (!this.form.persyaratan_id) {
        this.$swal.fire({ title: 'Peringatan', text: 'Silakan pilih jenis file persyaratan terlebih dahulu.', icon: 'warning' })
        return
      }
      if (!this.form.file) {
        return
      }

      this.form.uploading = true
      this.form.uploadSuccess = false
      this.form.uploadError = false
      this.form.uploadErrorMessage = ''

      this.form.post('/accountability-report-files', {
        onSuccess: () => {
          this.form.uploading = false
          this.form.uploadSuccess = true
          this.$swal.fire('Sukses', 'File persyaratan berhasil diunggah', 'success')
          setTimeout(() => {
            this.reset()
          }, 1500)
        },
        onError: (errors) => {
          this.form.uploading = false
          this.form.uploadError = true
          const list = Object.values(errors).join('\n')
          this.form.uploadErrorMessage = list
          this.$swal.fire('Gagal Upload', list, 'error')
        },
        preserveScroll: true,
      })
    },

    // Auto-upload for Penggunaan Anggaran
    autoUploadAnggaran() {
      if (!this.formAnggaran.category || !this.formAnggaran.description || !this.formAnggaran.amount) {
        this.$swal.fire({ title: 'Peringatan', text: 'Silakan lengkapi data penggunaan anggaran terlebih dahulu.', icon: 'warning' })
        return
      }
      if (!this.formAnggaran.file) {
        return
      }

      this.formAnggaran.uploading = true
      this.formAnggaran.uploadSuccess = false
      this.formAnggaran.uploadError = false
      this.formAnggaran.uploadErrorMessage = ''

      this.formAnggaran.post('/accountability-report-details', {
        onSuccess: () => {
          this.formAnggaran.uploading = false
          this.formAnggaran.uploadSuccess = true
          this.$swal.fire('Sukses', 'Penggunaan anggaran berhasil diunggah', 'success')
          setTimeout(() => {
            this.resetAnggaran()
          }, 1500)
        },
        onError: (errors) => {
          this.formAnggaran.uploading = false
          this.formAnggaran.uploadError = true
          const list = Object.values(errors).join('\n')
          this.formAnggaran.uploadErrorMessage = list
          this.$swal.fire('Gagal Upload', list, 'error')
        },
        preserveScroll: true,
      })
    },

    // Methods for Form File Persyaratan
    reset() {
      this.statusInput = false
      this.form.reset('persyaratan_id', 'file')
      this.form.uploading = false
      this.form.uploadSuccess = false
      this.form.uploadError = false
      this.form.uploadErrorMessage = ''
      this.imageData = ''
    },
    destroy(id) {
      this.confirmAction(
        'Anda yakin hapus file ini?',
        'Anda tidak akan dapat mengembalikan data yang sudah dihapus!',
        () => {
          this.$inertia.delete(`/accountability-report-files/${id}`)
        },
      )
    },

    // Methods for Form Penggunaan Anggaran
    resetAnggaran() {
      this.statusInputAnggaran = false
      this.formAnggaran.reset()
      this.formAnggaran.uploading = false
      this.formAnggaran.uploadSuccess = false
      this.formAnggaran.uploadError = false
      this.formAnggaran.uploadErrorMessage = ''
      this.imageDataAnggaran = ''
    },
    destroyDetail(id) {
      this.confirmAction(
        'Anda yakin hapus data penggunaan anggaran ini?',
        'Anda tidak akan dapat mengembalikan data yang sudah dihapus!',
        () => {
          this.$inertia.delete(`/accountability-report-details/${id}`)
        },
      )
    },

    // General Methods
    kirim() {
      this.confirmAction(
        'Anda yakin kirim Pertanggung Jawaban ini?',
        'Pastikan semua informasi dan file yang anda kirimkan sudah sesuai!',
        () => {
          this.$inertia.put(`/accountability-reports/${this.application.id}/send`)
        },
      )
    },
    confirmAction(title, text, onConfirm) {
      this.$swal.fire({
        title: title,
        text: text,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
      }).then((result) => {
        if (result.isConfirmed) {
          onConfirm()
        }
      })
    },
  },
}
</script>

<style scoped>
 .preview {
    max-width: 200px;
    border-radius: 0.5rem;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
 }
 .form-error {
    color: #b91c1c;
 }
 .form-valid {
    color: #15803d;
 }
</style>
